// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("./node_modules/error-overlay-webpack-plugin/dist/entries/basic.mjs");
__webpack_require__("./node_modules/error-overlay-webpack-plugin/dist/entries/devserver.mjs?&sockHost=local.payclip.com&sockPath=/ws&sockPort=9099");
var __webpack_exports__ = __webpack_require__("./src/index.js");
